var Item = /** @class */ (function () {
    function Item(productInfo, price, quantity) {
        this.productInfo = productInfo;
        this.price = price;
        this.quantity = quantity;
    }
    Item.prototype.getProductInfo = function () {
        return this.productInfo;
    };
    Item.prototype.getPrice = function () {
        return this.price;
    };
    Item.prototype.getQuantity = function () {
        return this.quantity;
    };
    return Item;
}());
export { Item };
